import React, { Component } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import './../../css/table.css';

const MySwal = withReactContent(Swal);

export default class CategoryJobOpportunityEdit extends Component {
    constructor() {
        super();
        this.state = {
            category: '',
            category_fa: '',
            loading: true,
            submitting: false
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.getCategory(id);
    }

    getCategory(id) {
        axios
            .get(`https://arianaapp.arianaapply.com/panel/show-cat-job-opportunity-single/${id}`)
            .then((res) => {
                const data = res.data.data;
                this.setState({
                    category: data.category || '',
                    category_fa: data.category_fa || '',
                    loading: false
                });
            })
            .catch((err) => {
                this.setState({ loading: false });
                MySwal.fire({
                    title: 'خطا در دریافت اطلاعات',
                    icon: 'error',
                }).then(() => {
                    this.props.history.push('/category-job-list');
                });
            });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const { category, category_fa } = this.state;
        const { id } = this.props.match.params;

        if (!category.trim() || !category_fa.trim()) {
            MySwal.fire({
                title: 'لطفاً همه فیلدها را پر کنید',
                icon: 'warning',
            });
            return;
        }

        this.setState({ submitting: true });

        axios
            .post(`https://arianaapp.arianaapply.com/panel/edit-cat-job-opportunity/${id}`, {
                category: category.trim(),
                category_fa: category_fa.trim()
            })
            .then((res) => {
                this.setState({ submitting: false });
                MySwal.fire({
                    title: 'دسته‌بندی با موفقیت ویرایش شد',
                    icon: 'success',
                }).then(() => {
                    this.props.history.push('/category-job-list');
                });
            })
            .catch((err) => {
                this.setState({ submitting: false });
                const message = err.response?.data?.message || 'خطا در ویرایش دسته‌بندی';
                MySwal.fire({
                    title: message,
                    icon: 'error',
                });
            });
    };

    render() {
        const { category, category_fa, loading, submitting } = this.state;

        if (loading) {
            return (
                <div className='index' style={{ textAlign: 'center', marginTop: '3rem' }}>
                    <Spinner animation='border' variant='primary' />
                </div>
            );
        }

        return (
            <div className='index'>
                <form onSubmit={this.handleSubmit} style={{ width: '90%', maxWidth: '700px' }}>
                    <h4 style={{ marginBottom: '1.5rem', color: '#693668', textAlign: 'center' }}>
                        ویرایش دسته‌بندی
                    </h4>

                    <div className='inputBox'>
                        <label>نام انگلیسی (category)</label>
                        <input
                            type='text'
                            name='category'
                            value={category}
                            onChange={this.handleChange}
                            required
                        />
                    </div>

                    <div className='inputBox'>
                        <label>نام فارسی (category_fa)</label>
                        <input
                            type='text'
                            name='category_fa'
                            value={category_fa}
                            onChange={this.handleChange}
                            required
                        />
                    </div>

                    <div className='inputBox' style={{ marginTop: '30px', display: 'flex', gap: '15px', flexDirection: 'row', justifyContent: 'center' }}>
                        <button
                            type='submit'
                            className='btn-success'
                            disabled={submitting}
                            style={{ width: '180px', marginBottom: 0 }}
                        >
                            {submitting ? <Spinner animation='border' size='sm' /> : 'ذخیره تغییرات'}
                        </button>

                        <Link to='/category-job-list'>
                            <button
                                type='button'
                                style={{
                                    width: '120px',
                                    height: '50px',
                                    borderRadius: '3px',
                                    border: 'none',
                                    background: '#dc3545',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    marginTop: '5px'

                                }}
                            >
                                انصراف
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        );
    }
}